import { Tag } from "@frends/ui-components/react";

export default Tag;
